import React, { useRef, useEffect, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom'

import { openOverlay } from "../../../store/actions/riskActions";
import { useTranslation } from "react-i18next";

const Matrix = ({ height, data, which, openExpanded, isExpanded, closeExpanded, openOverlayFN }) => {
    const { t } = useTranslation();
    const containerRef = useRef(null);
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

    const toUIX = (impact_category) => Number(impact_category);
    const toUIY = (probability) => Number(probability);

    useEffect(() => {
        if (containerRef.current) {
            setContainerSize({
                width: containerRef.current.offsetWidth,
                height: containerRef.current.offsetHeight,
            });
        }
    }, []);

    /*  let remote_data_dummy = [{
          impact_category: 2,
          probability: 3,
          risk_count: 1,
          risk_level: 2
      }]
  */


    ////////////console.log(which, data);
    const countRiskLevels = (data) => {
        const riskLevels = {
            low: 0,
            moderate: 0,
            high: 0,
            extreme: 0
        };

        //console.log("MATRIX: ", data)

        data && data.forEach(item => {
            switch (item.risk_level) {
                case 0:
                    riskLevels.low += item.risk_count;
                    break;
                case 1:
                    riskLevels.moderate += item.risk_count;
                    break;
                case 2:
                    riskLevels.high += item.risk_count;
                    break;
                case 3:
                    riskLevels.extreme += item.risk_count;
                    break;
                default:
                    break;
            }
        });

        return riskLevels;
    };





    const getLevelColor = (level) => {
        if (level === "low") return "bg-[#05769D]";
        if (level === "moderate") return "bg-[#09A6B0]";
        if (level === "high") return "bg-[#FED4AE]";
        return "bg-[#F07167]"; // extreme
    };


    const riskLevels = countRiskLevels(data);



    const getColor = (x, y) => {
        // Custom color pattern based on the screenshot
        const colors = [
            ["bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#F07167]", "bg-[#F07167]", "bg-[#F07167]"],
            ["bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]", "bg-[#F07167]", "bg-[#F07167]"],
            ["bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]", "bg-[#F07167]"],
            ["bg-[#05769D]", "bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]", "bg-[#FED4AE]"],
            ["bg-[#05769D]", "bg-[#05769D]", "bg-[#09A6B0]", "bg-[#09A6B0]", "bg-[#FED4AE]"]
        ];
        return colors[y][x];
    };

    /*const lineCoordinates = points && points.map(({ x, y }) => {
        const xOffset = (x + 1) * (containerSize.width / 5);
        const yOffset = (y + 1) * (containerSize.height / 5);
        return { x: xOffset, y: yOffset };
    });*/
    //////////console.log("riskLevels: ", riskLevels);


    const history = useHistory()
    const { pathname } = useLocation()




    //const [isExpanded, setIsExpanded] = React.useState(false);
    const [originRect, setOriginRect] = React.useState(null);

    // const openExpanded = () => {
    //     if (!containerRef.current) return;
    //     const rect = containerRef.current.getBoundingClientRect();
    //     setOriginRect(rect);
    //     setIsExpanded(true);
    // };

    // const closeExpanded = () => {
    //     setIsExpanded(false);
    // };

    const getExpandedTransform = () => {
        if (!originRect) return { transform: "translate(-50%, -50%) scale(1)" };

        // where the card currently is (center of it)
        const fromX = originRect.left + originRect.width / 2;
        const fromY = originRect.top + originRect.height / 2;

        // where we want it to go (center of screen)
        const toX = window.innerWidth / 2;
        const toY = window.innerHeight / 2;

        const dx = fromX - toX;
        const dy = fromY - toY;

        // start at original position, end at center
        return {
            transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(0.92)`,
        };
    };





 
    const points = React.useMemo(() => {
        return (data || []).map(item => ({
            x: toUIX(item.impact_category),
            y: toUIY(item.probability),
            value: item.risk_count
        }));
    }, [data]);


    
    const riskIdsByCell = React.useMemo(() => {
        const map = new Map();

        (data || []).forEach(cell => {
            const x = toUIX(cell.impact_category);
            const y = toUIY(cell.probability);
            const key = `${x}-${y}`;

            if (!map.has(key)) map.set(key, []);

            if (Array.isArray(cell.risk_ids)) {
                map.get(key).push(...cell.risk_ids);
            }
        });

        // de-dupe just in case
        for (const [k, v] of map.entries()) {
            map.set(k, [...new Set(v)]);
        }

        return map;
    }, [data]);


    const risksByCell = React.useMemo(() => {
  const map = new Map();

  (data || []).forEach((cell) => {
    const x = toUIX(cell.impact_category);
    const y = toUIY(cell.probability);
    const key = `${x}-${y}`;

    if (!map.has(key)) map.set(key, []);

    const arr = Array.isArray(cell.risks) ? cell.risks : [];

    // tolerate either {id,title} or {risk_id,Title} just in case
    arr.forEach((r) => {
      const id = r?.id ?? r?.risk_id;
      const title = r?.title ?? r?.Title ?? `Risk ${id}`;
      if (id != null) map.get(key).push({ id: Number(id), title });
    });
  });

  // de-dupe by id
  for (const [k, v] of map.entries()) {
    const seen = new Set();
    const deduped = [];
    for (const item of v) {
      if (!seen.has(item.id)) {
        seen.add(item.id);
        deduped.push(item);
      }
    }
    map.set(k, deduped);
  }

  return map;
}, [data]);




    const levelLabel = {
        low: t("riskCenter.levels.low"),
        moderate: t("riskCenter.levels.moderate"),
        high: t("riskCenter.levels.high"),
        extreme: t("riskCenter.levels.catastrophic"),
    };

    const onRiskClick = (risk) => {

        ////console.log("clicked risk", risk);
        let id = risk.risk_id
        const domain = pathname.split('/')[1] || ''
        // push new URL with risk ID param
        openOverlayFN(id)
        history.push(`/risk_overview/${id}`)

    };




    return (
        <>
            {/* NORMAL (in-page) */}
            <div className="relative">
                {/* Optional: click anywhere to expand */}
                <div onClick={openExpanded} className="cursor-pointer">
                    <div
                        ref={containerRef}
                        className="w-full flex flex-col items-center justify-center overflow-hidden relative h-full p-2"
                        style={{ height }}
                    >
                        {/* ... your existing content exactly as-is ... */}
                     <div className="flex w-full items-center justify-center gap-1 mt-2 flex-nowrap">
  {Object.entries(riskLevels).map(([level, count]) => (
    <div
      key={level}
      className="
        flex items-center justify-center
        rounded-md bg-white border border-gray-200
        flex-1 min-w-0
      "
      style={{ height: `${containerSize.height / 6 - 10}px` }}
    >
      <div className="flex items-center gap-2 px-2 min-w-0 w-full justify-center">
        <span className={`w-2.5 h-2.5 rounded-[3px] ${getLevelColor(level)} shrink-0`} />

        <span className="min-w-0 truncate text-xs md:text-sm lg:text-base font-medium text-gray-700">
          {levelLabel[level]}
        </span>

        <span className="text-xs md:text-sm lg:text-base text-gray-900 shrink-0">
          {count}
        </span>
      </div>
    </div>
  ))}
</div>

                        <div className="grid grid-rows-5 grid-cols-5 gap-1 w-full h-full p-2">
                            {["Almost Certain", "Likely", "Possible", "Unlikely", "Rare"].map((likelihood, rowIndex) => (
                                <React.Fragment key={rowIndex}>
                                    {[...Array(5)].map((_, colIndex) => (
                                        <div
                                            key={`${rowIndex}-${colIndex}`}
                                            className={`flex items-center justify-center rounded-md ${getColor(colIndex, rowIndex)}`}
                                            style={{ height: `${containerSize.height / 6 - 10}px` }}
                                        >
                                            {(() => {
                                                const pt = points?.find((p) => p.x === colIndex && p.y === 4 - rowIndex);
                                                if (!pt) return null;

                                                return (
                                                    <div className="flex items-center justify-center z-10">
                                                        <div
                                                            className="
        w-6 h-6 md:w-7 md:h-7
        rounded-full
        bg-black/40
        flex items-center justify-center
        transition-transform duration-150 ease-out
        hover:scale-125
    "
                                                        >

                                                            <span className="text-xs md:text-sm text-white font-semibold leading-none">
                                                                {pt.value}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>



            </div>

            {/* OVERLAY MODAL */}
            {isExpanded && (
                <div className="fixed inset-0 z-[9999]">
                    {/* backdrop */}
                    <div
                        className="absolute inset-0 bg-black/40"
                        onClick={closeExpanded}
                    />

                    {/* animated modal */}
                    <div
                        className="absolute left-1/2 top-1/2 transition-transform duration-200 ease-out"
                        style={getExpandedTransform()}
                    >
                        <div
                            className="bg-white rounded-xl shadow-2xl border border-gray-200"
                            style={{
                                width: "min(1000px, 92vw)",
                                height: "min(820px, 90vh)", // <- a bit taller
                            }}
                        >
                            {/* IMPORTANT: flex column + min-h-0 so children can shrink properly */}
                            <div className="w-full h-full flex flex-col min-h-0">
                                {/* header */}
                                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 shrink-0">
                                    <div className="flex flex-col">
                                        <div className="text-sm font-semibold text-gray-800">
                                            Risk Heatmap
                                        </div>
                                        <div className="text-xs text-gray-500 mt-0.5">
                                            Click on any risk dot to view details
                                        </div>
                                    </div>

                                    <button
                                        onClick={closeExpanded}
                                        className="px-2 py-1 text-sm rounded-md border border-gray-200 hover:bg-gray-50"
                                    >
                                        Close
                                    </button>
                                </div>


                                {/* content */}
                                <div className="flex-1 min-h-0 p-3">
                                    <div className="w-full h-full flex flex-col min-h-0 items-center justify-center relative">
                                        {/* legend row (fixed height) */}
                                        <div className="flex justify-center items-center gap-2 flex-nowrap mt-1 mb-2 shrink-0 w-full">
                                            {Object.entries(riskLevels).map(([level, count]) => (
                                                <div
                                                    key={`modal_${level}`}
                                                    className="flex items-center justify-center rounded-md bg-white border border-gray-200"
                                                    style={{ height: `64px` }}
                                                >
                                                    <div className="flex items-center gap-2 px-3">
                                                        <span className={`w-2.5 h-2.5 rounded-[3px] ${getLevelColor(level)}`} />
                                                        <span className="text-xs md:text-sm lg:text-base font-medium text-gray-700">
                                                            {levelLabel[level]}
                                                        </span>
                                                        <span className="text-xs md:text-sm lg:text-base font-semibold text-gray-900">
                                                            {count}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                        {/* grid + axes */}
                                        <div className="w-full flex-1 min-h-0 p-2">
                                            {/* axis title row */}
                                            <div className="flex items-center justify-between px-2 mb-2">
                                                <div className="text-xs font-semibold text-gray-600">Likelihood</div>
                                                <div className="text-xs font-semibold text-gray-600">Impact</div>
                                            </div>

                                            {/* layout: [y-labels | matrix] and bottom x-labels */}
                                            <div className="w-full h-full grid grid-cols-[120px_1fr] grid-rows-[1fr_44px] gap-2 min-h-0">
                                                {/* Y-axis labels */}
                                                <div className="row-start-1 col-start-1 flex flex-col justify-between pr-2">
                                                    {["Almost Certain", "Likely", "Possible", "Unlikely", "Rare"].map((lbl) => (
                                                        <div key={lbl} className="text-xs text-gray-500 font-medium h-[20%] flex items-center justify-end">
                                                            {lbl}
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Matrix */}
                                                <div className="row-start-1 col-start-2 min-h-0">
                                                    <div className="grid grid-rows-5 grid-cols-5 gap-2 w-full h-full">
                                                        {["Almost Certain", "Likely", "Possible", "Unlikely", "Rare"].map((likelihood, rowIndex) => (
                                                            <React.Fragment key={`modal_row_${rowIndex}`}>
                                                                {[...Array(5)].map((_, colIndex) => (
                                                                    <div
                                                                        key={`modal_${rowIndex}-${colIndex}`}
                                                                        className={`relative rounded-md ${getColor(colIndex, rowIndex)} overflow-hidden`}
                                                                    >
                                                                        {/* score badge */}
                                                                        <div className="
        absolute top-1 left-1
        text-[10px] font-semibold
       text-black
        px-1.5 py-0.5
        rounded
        pointer-events-none
    ">
                                                                            {(5 - rowIndex) * (colIndex + 1)}
                                                                        </div>

                                                                        {(() => {
                                                                            const x = colIndex;     // impact_category
                                                                            const y = 4 - rowIndex; // probability
                                                                            const risks = risksByCell.get(`${x}-${y}`) || [];
                                                                            if (!risks.length) return null;

                                                                            return (
                                                                                <div className="w-full h-full p-2 flex flex-col gap-1 overflow-auto">
                                                                                    {risks.map((risk) => (
                                                                                        <button
                                                                                            key={risk.id}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                onRiskClick({
                                                                                                    risk_id: risk.id,
                                                                                                    probability: y,
                                                                                                    impact_category: x,
                                                                                                    which,
                                                                                                });
                                                                                            }}
                                                                                            className="text-xs text-white bg-black/20 hover:bg-black/30 rounded px-2 py-1 text-left truncate"
                                                                                            title={risk.title}
                                                                                        >
                                                                                            {risk.title}
                                                                                        </button>
                                                                                    ))}
                                                                                </div>
                                                                            );

                                                                        })()}
                                                                    </div>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* X-axis labels */}
                                                <div className="row-start-2 col-start-2 grid grid-cols-5 gap-2 items-center">
                                                    {["Insignificant", "Minor", "Mod", "Major", "Catastrophe"].map((lbl, i) => (
                                                        <div key={i} className="text-xs text-gray-500 font-medium text-center">
                                                            {lbl}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* keep your animation kick if you want */}
                        <style>{`
        .fixed.inset-0 .absolute.left-1\\/2.top-1\\/2 {
          transform: translate(-50%, -50%) scale(1) !important;
        }
      `}</style>
                    </div>
                </div>
            )}

        </>
    );
};

export default Matrix;
